import React from "react"

const NotFound = props => {
    return (
        <h1>NotFound</h1>
    )
}

export default NotFound